module.exports = __webpack_public_path__ + "static/img/redirect-load.1637acad.gif";